import React from 'react';
import { WAREHOUSE_DEAL_CREATE } from '../../../../router/routes';
import { route } from '../../../../services/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBoxCheck,
  faBoxFull,
  faCoins,
  faRecycle,
  faRepeat,
  faExchange,
} from '@fortawesome/pro-solid-svg-icons';
import { faMinus, faPlus } from '@fortawesome/pro-regular-svg-icons';
import couchImage from './couch.svg';
import lostLeftoverIcon from './lost-leftover.svg';
import css from './create-buttons.module.css';
import DealType from '../../../../enums/deal-type';
import ActionContainer from '../../../../components/action-button/container';
import ActionButton from '../../../../components/action-button/button';
import { useTranslation } from 'react-i18next';

export default function CreateButtons({ farmId }: { farmId: string }) {
  const { t } = useTranslation();

  return (
    <ActionContainer>
      <ActionButton
        name={DealType.purchased}
        icon={
          <>
            <FontAwesomeIcon className={css['small']} icon={faPlus} />
            <FontAwesomeIcon icon={faCoins} />
          </>
        }
        route={route(WAREHOUSE_DEAL_CREATE, {
          dealType: DealType.purchased,
          farmId,
        })}
        text={t(`classifiers.${DealType.purchased}`)}
      />
      <ActionButton
        name={DealType.sold}
        icon={
          <>
            <FontAwesomeIcon className={css['small']} icon={faMinus} />
            <FontAwesomeIcon icon={faBoxCheck} />
          </>
        }
        route={route(WAREHOUSE_DEAL_CREATE, {
          dealType: DealType.sold,
          farmId,
        })}
        text={t(`classifiers.${DealType.sold}`)}
      />
      <ActionButton
        name={DealType.produced}
        icon={
          <>
            <FontAwesomeIcon className={css['small']} icon={faPlus} />
            <img src={couchImage} alt="" className={css['sign-in-logo']} />
          </>
        }
        route={route(WAREHOUSE_DEAL_CREATE, {
          dealType: DealType.produced,
          farmId,
        })}
        text={t(`classifiers.${DealType.produced}`)}
      />
      <ActionButton
        name={DealType.spent}
        icon={
          <>
            <FontAwesomeIcon className={css['small']} icon={faMinus} />
            <FontAwesomeIcon icon={faBoxFull} />
          </>
        }
        route={route(WAREHOUSE_DEAL_CREATE, {
          dealType: DealType.spent,
          farmId,
        })}
        text={t(`classifiers.${DealType.spent}`)}
      />
      <ActionButton
        name={DealType.recycled}
        icon={<FontAwesomeIcon icon={faRecycle} />}
        route={route(WAREHOUSE_DEAL_CREATE, {
          dealType: DealType.recycled,
          farmId,
        })}
        text={t(`classifiers.${DealType.recycled}`)}
      />
      <ActionButton
        name={DealType.self_consumed}
        icon={<FontAwesomeIcon icon={faRepeat} />}
        route={route(WAREHOUSE_DEAL_CREATE, {
          dealType: DealType.self_consumed,
          farmId,
        })}
        text={t(`classifiers.${DealType.self_consumed}`)}
      />
      <ActionButton
        name={DealType.lost}
        icon={<img src={lostLeftoverIcon} alt="" />}
        route={route(WAREHOUSE_DEAL_CREATE, {
          dealType: DealType.lost,
          farmId,
        })}
        text={
          t(`classifiers.${DealType.lost}`) +
          '/' +
          t(`classifiers.${DealType.leftover}`).toLowerCase()
        }
      />
      <ActionButton
        name={DealType.moved}
        icon={<FontAwesomeIcon icon={faExchange} />}
        route={route(WAREHOUSE_DEAL_CREATE, {
          dealType: DealType.moved,
          farmId,
        })}
        text={t(`classifiers.${DealType.moved}`)}
      />
    </ActionContainer>
  );
}
